module.exports = __webpack_public_path__ + "static/forms-1dbeac353c40cc546f55b34adcdbc371.png";